import { LOGIN, LOGOUT, UPDATE_USER, FIRE_BASE_LOGIN } from "../actions/type.action";
const initialAuth = {
  user: {
    _id:'5f8af23aed3d390017dc72e7',
    admin:true,
    company:'e-ERP-TN',
    companyId:"5fbc0859edea6cc6ccd974d1",
    companiesId:["5fbc0859edea6cc6ccd974d1"],
    name:'developper',
    email:'developper@developper.com',
    // password:'devdotdev',
    color:'#AAAAAA',
    avatar:'https://i.imgur.com/cVDadwb.png',
    rules:{
      general:['main:visit', 'user:crud'],
      dashboard:['main:visit', 'project:crud', 'companyKPI:visit'],
      kanban:['main:visit'],
      timeline:['main:visit'],
      gantt:['main:visit'],
    },
    project:[],
    collaboratedwith:[],
    connection:{status:'online'},
    companyRules:{
      projectMg:['main:visit'],
      clientRelationMg:['main:visit'],
      cashFlowMg:['main:visit'],
      humanRessourcesMg:['main:visit'],
      inventoryMg:['main:visit']
    }
  },
  isAuthenticated: false,
  authError: false,
};

export const authReducer = (state = initialAuth, action) => {
  switch (action.type) {
  case FIRE_BASE_LOGIN:
    return {
      ...state,
      isAuthenticated: action.payload.auth,
      authError: action.payload.error,
    };
  case LOGIN:
    return {
      ...state,
      isAuthenticated: true,
      authError: false,
      user: action.payload,
    };
  case UPDATE_USER:
    return {
      ...state,
      isAuthenticated: true,
      user: action.payload,
    };
  case LOGOUT:
    return {
      ...state,
      isAuthenticated: false,
    };

  default:
    return state;
  }
};
